export const defaultPagination = {
	page: 1,
	perPage: 10,
	total: undefined,
	totalPages: undefined,
};

export const defaultCurrencies = ['BDT', 'EUR', 'JPY', 'KES', 'MDL', 'PHP', 'USD'];
